module.exports = __webpack_public_path__ + "static/CircularStd-Medium-fd8ea5d7c00201fe4f5e38d3667c98f5.ttf";